module.exports = __webpack_public_path__ + "media/images/landing_section_2-99f956eceed3b37d423f82f3662fbc9b.svg";